export interface TableSkeletonProps {
  /** Что грузим — для читалки: «Загружаем каталог…». */
  what: string
  rows?: number
}

/**
 * Загрузка таблицы: макет строк на месте будущих данных, а не строка по
 * центру. Экран не прыгает, когда данные приходят, а читалка слышит, что
 * именно грузится.
 */
export function TableSkeleton({ what, rows = 6 }: TableSkeletonProps) {
  return (
    <div className="ui-table-wrap ui-skel-table" role="status">
      <span className="visually-hidden">Загружаем {what}…</span>
      {Array.from({ length: rows }, (_, i) => (
        <div className="row" key={i} aria-hidden="true">
          <span className="ui-skeleton thumb" />
          <span className="lines">
            <span className="ui-skeleton" style={{ width: `${70 - (i % 3) * 12}%` }} />
            <span className="ui-skeleton short" />
          </span>
          <span className="ui-skeleton cell" />
          <span className="ui-skeleton cell" />
        </div>
      ))}
    </div>
  )
}
